module.exports = __webpack_public_path__ + "img/o-movie-theater.6ccc51a2.jpg";